import gql from "graphql-tag";

export const REMOVE_INVITE_MUTATION = gql`
  mutation RemoveInvite($email: String!) {
    removeInvite(email: $email) {
      ok
    }
  }
`;
